<template>
  <div>
    <div>
      <search-bar></search-bar>
    </div>
    <div v-if="result && isfound">{{prodis}}</div>
    <!--
    <div v-if="result && isfound">
      <v-stepper v-model="e4" class="py-0 px-1">
        <v-stepper-header class="py-1 px-1">
          <template v-for="(n, row) in UIText.length">
            <v-stepper-step class="py-1 px-0" :key="`${n}-step`" :step="n" editable>
              <span class="ttext" v-html="UIText[row][0]"></span>
            </v-stepper-step>
            <v-divider v-if="n !== UIText.length" :key="n"></v-divider>
          </template>
        </v-stepper-header>
        <v-stepper-items>
          
          <v-stepper-content class="pa-1" step="1">
            <page1 :title="UIText[0]" :sch_con="preDt.sch_con[0]" :sch_inch="preDt.sch_inch" 
            :sch_iden="preDt.sch_iden" :ProName_KH="preDt.proKH" :DisName_KH="preDt.disKH"
            :Commune_KH="preDt.comKH" :Village_KH="preDt.vilKH" :schKH="preDt.schKH"
            :schnewKH="preDt.schnewKH" :schENG="preDt.schENG" :schnewENG="preDt.schnewENG" 
            :loc_code="preDt.loc_code"/>
          <v-btn color="primary" class="ttext" @click.native="e4=2">បន្ត</v-btn>
          </v-stepper-content>
          
          <v-stepper-content class="py-1 px-1" step="2">
            <v-card color="grey lighten-1" class="mb-1">
              <page2 :title="UIText[1]" :stu_pre="preDt.stu_pre" :dis_pre="preDt.dis_pre" 
              :eth_pre="preDt.eth_pre" :lst_pre="preDt.lst_pre" :lst_acc="accademic.lst_text"
              :cur_acc="accademic.cur_text"/>
            </v-card>
            <v-btn color="primary" class="ttext" @click.native="e4=3">បន្ត</v-btn>
          </v-stepper-content>
          
          <v-stepper-content class="py-1 px-1" step="3">
            <v-card color="grey lighten-1" class="mb-1">
              <page3 :title="UIText[2]" :cla_env="preDt.cla_env" :mate="preDt.mate" 
              :mat_toy="preDt.mat_toy"/>
            </v-card>
            <v-btn color="primary" class="ttext" @click.native="e4=4">បន្ត</v-btn>
          </v-stepper-content>
          
          <v-stepper-content class="py-1 px-1" step="4">
            <v-card color="grey lighten-1" class="mb-1">
              <page4 :title="UIText[3]" :sta_sal="preDt.sta_sal" :sta_fun="preDt.sta_fun" 
              :sta_tra="preDt.sta_tra"/>
            </v-card>
            <v-btn color="primary" class="ttext" @click.native="e4=5">បន្ត</v-btn>
          </v-stepper-content>
          
          <v-stepper-content class="py-1 px-1" step="5">
            <v-card color="grey lighten-1" class="mb-1">
              <page5 :title="UIText[4]" :fac_5a="preDt.fac_5a" :fac_5b="preDt.fac_5b"
              :fac_5c="preDt.fac_5c" :fac_5cc="preDt.fac_5cc" :uti_5d="preDt.uti_5d"
              :uti_5e="preDt.uti_5e" :uti_5f="preDt.uti_5f" :uti_5g="preDt.uti_5g"
              :uti_5h1="preDt.uti_5h1" :uti_5h2="preDt.uti_5h2"/>
            </v-card>
            <v-btn color="primary" class="ttext" @click.native="e4=6">បន្ត</v-btn>
          </v-stepper-content>
          
          <v-stepper-content class="py-1 px-1" step="6">
            <v-card color="grey lighten-1" class="mb-1">
              <page6 :title="UIText[5]" :com_par="preDt.com_par[0]" :fin_anc="preDt.fin_anc"
              :lst_acc="accademic.lst_text"/>
            </v-card>
            <v-btn color="primary" class="ttext" @click.native="e4=7">បន្ត</v-btn>
          </v-stepper-content>
          
          <v-stepper-content class="py-1 px-1" step="7">
            <v-card color="grey lighten-1" class="mb-1">
              <page7 :title="UIText[6]" :int_wor="preDt.int_wor[0]" :lst_acc="accademic.lst_text"/>
            </v-card>
            <v-btn color="primary" class="ttext" @click.native="e4=1">ត្រលប់</v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
    -->

    <div v-if="result && isfound">
      <navigation-bar></navigation-bar>
    </div>
  </div>
</template>
<script>
import SearchBar from "@/components/common/SearchBar.vue";
import NavigationBar from "@/components/common/NavigationBar.vue";
import prodisModule from "@/store/modules/prodis/index";
/*
import { preUIText } from '@/utils/ascf/preConfig.js'

const page1 = () => import('@/components/ascf/pre/page1.vue')
const page2 = () => import('@/components/ascf/pre/page2.vue')
const page3 = () => import('@/components/ascf/pre/page3.vue')
const page4 = () => import('@/components/ascf/pre/page4.vue')
const page5 = () => import('@/components/ascf/pre/page5.vue')
const page6 = () => import('@/components/ascf/sharedCom/page6.vue')
const page7 = () => import('@/components/ascf/sharedCom/page7.vue')
*/
export default {
  name: "prodisLevel",
  components: {
    searchBar: SearchBar,
    navigationBar: NavigationBar,
    /*
    ,
    'page1': page1,
    'page2': page2,
    'page3': page3,
    'page4': page4,
    'page5': page5,
    'page6': page6,
    'page7': page7
    */
  },
  data() {
    return {
      isfound: false,
      e4: 1,
      // UIText: preUIText,
      active: "t1", // this.$store.state.uiControl.selTab
    };
  },
  methods: {},
  computed: {
    /* eslint-disable */

    result: function () {
      if (this.$store.state.prodis.pd.res >= 1) {
        this.isfound = true;
        this.active = "t1";
        return true;
      } else {
        return false;
      }
    },

    /* eslint-enable */
    prodis: function () {
      return this.$store.state.prodis.pd;
    },
    savTab: function () {
      let sTab;
      return sTab;
    }, // getting the current Academic_text and last Academic_text
    accademic: function () {
      return {
        acc_code: this.$store.state.uiControl.cur_acc_code,
        cur_text: this.$store.state.uiControl.cur_acc_text,
        lst_text: this.$store.state.uiControl.lst_acc_text,
      };
    },
  },
  mounted() {
    this.$store.dispatch("prodis/loadDefaultProDis");
    this.$store.dispatch("uiControl/setEnableSave");
  },
  beforeDestroy() {
    // console.log('unreg pre')
    // this.$store.unregisterModule('pubascf')
  },
  created() {
    if (!this.$store._modules.root._children[`prodis`]) {
      // console.log('reg pre')
      this.$store.registerModule("prodis", prodisModule);
    }
  },
};
</script>

<style scoped>
.ttext {
  font-family: "khmer";
  font-weight: bold;
  font-size: 12px;
}
</style>